export function detectFileType(byteArray) {
  // PDF: starts with %PDF
  if (
    byteArray[0] === 0x25 &&
    byteArray[1] === 0x50 &&
    byteArray[2] === 0x44 &&
    byteArray[3] === 0x46
  ) {
    return { mimeType: "application/pdf", extension: "pdf" };
  }

  // PNG: starts with 89 50 4E 47
  if (
    byteArray[0] === 0x89 &&
    byteArray[1] === 0x50 &&
    byteArray[2] === 0x4e &&
    byteArray[3] === 0x47
  ) {
    return { mimeType: "image/png", extension: "png" };
  }

  // JPEG: starts with FF D8 FF
  if (byteArray[0] === 0xff && byteArray[1] === 0xd8 && byteArray[2] === 0xff) {
    return { mimeType: "image/jpeg", extension: "jpg" };
  }

  // DOCX: starts with 50 4B 03 04 (ZIP file signature)
  if (
    byteArray[0] === 0x50 &&
    byteArray[1] === 0x4b &&
    byteArray[2] === 0x03 &&
    byteArray[3] === 0x04
  ) {
    return {
      mimeType:
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      extension: "docx",
    };
  }

  // Fallback
  return { mimeType: "application/octet-stream", extension: "bin" };
}
